import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { 
  Box, 
  Flex, 
  useDisclosure, 
  Drawer, 
  DrawerContent,
  DrawerOverlay
} from '@chakra-ui/react';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';

/**
 * Layout component for admin pages
 * Includes admin sidebar, header, and content area
 */
const AdminLayout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isMobile, setIsMobile] = useState(false);

  // Handle responsive sidebar
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Flex h="100vh" flexDirection="column">
      {/* Mobile drawer for sidebar */}
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <AdminSidebar onClose={onClose} />
        </DrawerContent>
      </Drawer>

      {/* Header */}
      <AdminHeader onOpen={onOpen} />

      {/* Main content area */}
      <Flex flex="1" overflow="hidden">
        {/* Desktop sidebar - always visible on larger screens */}
        {!isMobile && (
          <Box
            w="250px"
            bg="white"
            borderRight="1px"
            borderColor="gray.200"
            h="calc(100vh - 64px)"
            flexShrink={0}
            overflow="hidden"
          >
            <AdminSidebar />
          </Box>
        )}

        {/* Main content */}
        <Box
          flex="1"
          p={4}
          overflowY="auto"
          bg="background.muted"
          minH="calc(100vh - 64px)"
          w="100%"
        >
          <Outlet />
        </Box>
      </Flex>
    </Flex>
  );
};

export default AdminLayout;
